import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Legend extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['form-legend']: true
        });

        return (
            <h4 className={classNames} {...props}>
                {children}
            </h4>
        );
    }
}

Legend.defaultProps = {};

export default Legend;
